export default "__VITE_ASSET__2b407592__"